var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.dialogTitle)}}),_c('v-card-text',{domProps:{"textContent":_vm._s(_vm.dialogMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }